import { RefObject } from 'react';
import { DialogHandle } from '@monorepo/nova-ui';
import { PayoutSource, WithdrawBlockReason } from '@monorepo/types';

export enum PayoutStage {
  Form = 'form',
  Confirmation = 'confirmation',
  Success = 'success',
}

export enum PayoutSuccessBehavior {
  CloseModal = 'close-modal',
  SuccessStage = 'success-stage',
}

export interface PayoutRequestFormProps {
  maxWithdrawal: number;
  credits: number;
  userPayoutPercentage: number;
  reason?: WithdrawBlockReason;
  showAmountSelection?: boolean;
  disabled?: boolean;
  sourceId: string;
  displayName: string;
  source: PayoutSource;
  validateWithDrawEligible: () => Promise<void>;
  modalRef: RefObject<DialogHandle | null>;
  isAffiliate?: boolean;
}
